export const CasterServiceBaseUrl = 'https://api.caster.warnerbros.com';
export const CasterServiceWSBaseUrl = 'wss://wsapi.caster.warnerbros.com';
export const CasterSharedServiceBaseUrl = '';
export const OKTA_CLIENT_ID = "0oa7qim81nsHMQBYZ4x7";
export const OKTA_ISSUER_URL = "https://ssobiz.wbd.com/oauth2/default";
export const OKTA_REDIRECT_URL = window.location.origin + '/callback';
export const OKTA_URL = "https://ssobiz.wbd.com";
export const IDLE_TIMEOUT = "60";
export const IDLE_WARN_TIMEOUT = "30";